export default {
  SET_GRANT_APPLICATIONS(state, data) {
    state.grantApplications = data;
  },
};
